<template>
  <div class="bc-white padding-20 br-4">
    <div class="display-flex jc-space-between ai-flex-start">
      <el-form :inline="true" size="small" v-model="searchForm">
        <el-form-item label="">
          <el-input
            placeholder="标识名称"
            clearable
            v-model="searchForm.fuzzyName"
          ></el-input>
        </el-form-item>
        <el-form-item label="">
          <el-select
            class="width-140"
            clearable
            placeholder="标识类型"
            v-model="searchForm.type">
            <el-option
              v-for="item in typeList"
              :key="item.id"
              :label="item.name"
              :value="item.id">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="">
          <el-button type="primary" @click="getTableData">查询</el-button>
        </el-form-item>
      </el-form>
      <div class="display-flex">
        <el-button
          type="primary"
          icon="el-icon-plus"
          size="small"
          @click="add">
          新增
        </el-button>
      </div>
    </div>
    <el-table
      border
      :data="tableData">
      <el-table-column
        align="center"
        prop="name"
        label="标识图片">
        <template #default="slotProps">
          <img width="80" :src="slotProps.row.imgUrl" alt="">
        </template>
      </el-table-column>
      <el-table-column
        align="center"
        prop="name"
        label="标识名称">
      </el-table-column>
      <el-table-column
        align="center"
        prop="fxWarnSignTypeName"
        label="标识类型">
      </el-table-column>
      <el-table-column
        align="center"
        prop="useScope"
        label="设置范围和地点">
      </el-table-column>
      <el-table-column
        align="center"
        prop="remark"
        label="备注">
      </el-table-column>
      <el-table-column
        align="center"
        width="120px"
        label="操作">
        <template #default="slotProps">
          <el-button @click="edit(slotProps.row)" type="text">编辑</el-button>
          <el-button @click="del(slotProps.row)" class="color-danger" type="text">删除</el-button>
        </template>
      </el-table-column>
    </el-table>
    <div class="display-flex fd-row-reverse mt-20">
      <!-- 表格数据的分页的功能 -->
      <el-pagination
        hide-on-single-page
        @current-change="(val) => {searchForm.page = val}"
        :current-page="searchForm.page"
        :page-size="searchForm.limit"
        background
        layout="total, prev, pager, next, jumper"
        :total="total">
      </el-pagination>
    </div>
    <el-dialog
      size="500px"
      :title="dialog.title"
      :visible.sync="dialog.show">
      <el-form
          class="diy-top-form"
          :model="dialog.form"
          ref="ruleForm"
          label-width="120px"
          label-position="top"
         >
          <el-form-item
            label="标识图片："
            prop="imgKey"
            :rules="{required: true, message: '请选择图片', trigger: 'change'}">
            <el-upload
              class="height-80"
              accept=".jpg,.png"
              :show-file-list="false"
              :http-request="uploadFile"
              action="">
              <img v-if="dialog.form.imgUrl" width="80" height="80" :src="dialog.form.imgUrl" alt="">
              <div v-else class="width-80 height-80 display-flex ai-center jc-center" style="border: 1px solid #DCDFE6;">
                <i class="el-icon-plus fs-28 color-info"></i>
              </div>
            </el-upload>
          </el-form-item>
          <el-form-item
            label="标识名称："
            prop="name"
            :rules="{required: true, message: '请输入标识名称', trigger: 'blur'}">
            <el-input placeholder="请输入标识名称" v-model="dialog.form.name"></el-input>
          </el-form-item>
          <el-form-item
            label="标识类型："
            prop="fxWarnSignTypeId"
            :rules="{required: true, message: '请选择标识类型', trigger: 'blur'}">
            <el-select
              class="width-percent-100"
              clearable
              placeholder="请选择标识类型"
              v-model="dialog.form.fxWarnSignTypeId">
              <el-option
                v-for="item in typeList"
                :key="item.id"
                :label="item.name"
                :value="item.id">
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item
            label="设置范围和地点："
            prop="useScope"
            :rules="{required: true, message: '请输入设置范围和地点', trigger: 'blur'}">
            <el-input placeholder="请输入设置范围和地点" v-model="dialog.form.useScope"></el-input>
          </el-form-item>
          <el-form-item label="备注：">
            <el-input :autosize="{minRows: 4, maxRows: 8}" type="textarea" v-model="dialog.form.remark" placeholder="请输入备注"></el-input>
          </el-form-item>
        </el-form>
      <template #footer>
        <el-button type="primary" @click="submit">确认</el-button>
        <el-button @click="dialog.show = false">取消</el-button>
      </template>
    </el-dialog>
  </div>
</template>

<script>
import _ from 'lodash';

export default {
  name: 'IconLibrary',
  components: {},
  props: {},
  data () {
    return {
      showUrl: '',
      typeList: [],
      searchForm: {
        fuzzyName: '',
        type: '',
        page: 1,
        limit: 10
      },
      tableData: [],
      total: 0,
      dialog: {
        show: false,
        title: '新增',
        form: {
          id: '',
          fxWarnSignTypeId: '',
          imgUrl: '',
          imgKey: '',
          name: '',
          remark: '',
          useScope: ''
        }
      }
    }
  },
  filters: {},
  computed: {
    /**
     * 监听复杂数据类型的变换
     */
    _searchForm () {
      return JSON.parse(JSON.stringify(this.searchForm))
    }
  },
  watch: {
    _searchForm: {
      handler: function (newVal, oldVal) {
        if (newVal.page !== 1 && newVal.page === oldVal.page) {
          this.searchForm.page = 1;
        } else {
          this.getTableData()
        }
      },
      deep: true
    }
  },
  methods: {
    add () {
      this.dialog = {
        show: true,
        title: '新增',
        form: {
          id: '',
          fxWarnSignTypeId: '',
          imgUrl: '',
          imgKey: '',
          name: '',
          remark: '',
          useScope: ''
        }
      }
    },
    edit (row) {
      this.dialog = {
        show: true,
        title: '编辑',
        form: {
          id: row.id,
          fxWarnSignTypeId: row.fxWarnSignTypeId,
          imgUrl: row.imgUrl,
          imgKey: row.imgKey,
          name: row.name,
          remark: row.remark,
          useScope: row.useScope
        }
      }
    },
    del (row) {
      this.$confirm('此操作将永久删除该数据, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.$api.iconLibrary.del({ id: row.id }).then(res => {
          this.$message.success('删除成功')
          this.searchForm.page = 1
          this.getTableData()
        })
      }).catch(() => {});
    },
    uploadFile (e) {
      const loading = this.$loading({
        lock: true,
        text: '上传中,请稍后',
        spinner: 'el-icon-loading',
        background: 'rgba(0, 0, 0, 0.7)'
      })
      const param = new FormData()
      param.append('file', e.file)
      this.$api.common.upload(param).then(res => {
        this.dialog.form.imgUrl = res.url
        this.dialog.form.imgKey = res.key
        loading.close()
      }).catch(() => {
        loading.close()
      })
    },
    submit () {
      this.$refs.ruleForm.validate(valid => {
        if (valid) {
          if (this.dialog.form.id) {
            this.$api.iconLibrary.update(this.dialog.form).then(res => {
              this.$message.success('编辑成功')
              this.getTableData()
              this.dialog.show = false
            })
          } else {
            this.$api.iconLibrary.save(this.dialog.form).then(res => {
              this.$message.success('添加成功')
              this.searchForm.page = 1
              this.getTableData()
              this.dialog.show = false
            })
          }
        }
      })
    },
    getTableData: _.debounce(function () {
      const data = {
        pageNum: this.searchForm.page,
        pageSize: this.searchForm.limit,
        name: this.searchForm.fuzzyName,
        fxWarnSignTypeId: this.searchForm.type
      }
      this.$api.iconLibrary.list(data).then(res => {
        this.tableData = res.list
        this.total = res.total
      })
    }, 500)
  },
  beforeCreate () {
  },
  created () {

  },
  beforeMount () {
  },
  mounted () {
    this.$api.iconLibrary.type().then(res => {
      this.typeList = res
    })
    this.getTableData()
  },
  beforeUpdate () {
  },
  updated () {
  },
  beforeDestroy () {
  },
  destroyed () {
  }
}
</script>

<style lang="scss" scoped>

</style>
